module.exports = __webpack_public_path__ + "static/media/Rumah Dongeng Pelangi.7e5d0036.png";